import { Tabs, TabsProps } from "antd";
import styled from "styled-components";
import { useEffect } from "react";
import CustomerWorktime from "./customer-worktime";
import CustomerInvoice from "./customer-invoice";
import CustomerTimesheet from "./customer-timesheet";

const TabsStyled = styled(Tabs)`
  flex: 1;

  .ant-tabs-content, .ant-tabs-tabpane {
    height: 100%;
  }
`

function CustomerSettlement({ subpage, subSubPage, setSubpage, customerId, customer }) {

  useEffect(() => {
    if(!subpage) {
      setSubpage('worktime');
    }
  }, [subpage, setSubpage])
  
    const tabItems: TabsProps['items'] = [
      {
        key: 'worktime',
        label: 'Zeiterfassung',
        children: <CustomerWorktime customerId={customerId} />,
      },
      {
        key: 'timesheet',
        label: 'Leistungsnachweise',
        children: <CustomerTimesheet customerId={customerId} customer={customer} />
      },
      {
        key: 'invoice',
        label: 'Rechnungen',
        children: <CustomerInvoice customerId={customerId} subpage={subSubPage} />,
      },
    ];
  
    return (
      <div  style={{ height: "100%", overflow: "scroll", display: 'flex', flexDirection: 'column' }}>
          <TabsStyled items={tabItems} activeKey={subpage} onChange={newSubpage => setSubpage(newSubpage)} />
      </div>
    )
}

export default CustomerSettlement;